import { render } from "./beCookieBanner.vue?vue&type=template&id=170022a8"
import script from "./beCookieBanner.vue?vue&type=script&lang=js"
export * from "./beCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__